import React from 'react'
import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph, Button, DangerButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentDelete } from '@fs/zion-icon'

export default function ConfirmRemoveEventOverlay({ confirmRemoveEventOverlay, removeEvent }) {
  const [t] = useTranslation()

  const cancelRemoveEventClicked = () => {
    confirmRemoveEventOverlay.close()
  }

  return (
    <DialogOverlay {...confirmRemoveEventOverlay} title={t('confirm-remove-overlay.title', 'Are you sure?')}>
      <Paragraph size="sm">
        {t(
          'confirm-remove-event-overlay.content',
          'Once the event is removed, you will not be able to restore the information.'
        )}
      </Paragraph>
      <Paragraph size="sm">{t('confirm-remove-event-overlay.content-2', 'Please confirm this change.')}</Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <DangerButton
            onClick={removeEvent}
            Icon={ContentDelete}
            data-testid="confirm-remove-button"
            linkName="Confirm Remove Event Submit"
          >
            {t('confirm-remove-event-overlay.remove-button', 'Remove Event')}
          </DangerButton>
          <Button
            onClick={cancelRemoveEventClicked}
            linkName="Confirm Remove Event Cancel"
            data-testid="remove-event-cancel-button"
          >
            {t('edit-index.cancel.button', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
